module.exports = __webpack_public_path__ + "img/work-9.6a25acf3.png";